import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../../environments/environment';
import { IClient } from '../models/book-of-business.interface';

@Injectable({
  providedIn: 'root',
})
export class BookOfBusinessRepository {

  constructor(private http: HttpClient) {}

  getBookOfBusiness(): Observable<IClient[]> {
    const url = `${environment.apiUrl}/api/v1/BookOfBusiness`;
    return this.http.get<IClient[]>(url);
  }
}
